module.exports = __webpack_public_path__ + "static/visionar-studio-loop-dd28ff2d549d5bc672a38f53f4ece37f.mp4";